import React from "react";
import { withRouter } from "react-router-dom";
import CONSTANT from "./../../../constant";
import Loader from "./../../../component/common/Loader";
import AparEmployeeHeader, { normalizeManagers } from "./../../../component/common/AparEmployeeHeader";
import { getPersonalAttributeMasterList, getPersonalAttributeGrade, savePersonalAttributeGrade, updatePersonalAttributeGrade } from "./../../../actions/AppraisalCycleAction";
import { getUserDetail } from "./../../../utils";

class aparReviewingManagerForm2 extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      showLoader: false,
      employeeData: null,
      kpiReportId: null,
      hasExistingGrades: false,
      isSubmitted: false,
      personalAttributes: [] as any[],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Personal Attributes Assessment - " + CONSTANT.organisation.name;

    const locationState = this.props.location?.state || {};
    const { kpiReportId, employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo } = locationState;
    const employeeData = { employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo, ...normalizeManagers(locationState) };

    this.setState({ employeeData, kpiReportId, showLoader: true });

    // Fetch master attributes, then reporting manager's grades
    getPersonalAttributeMasterList().then((res: any) => {
      const masterList = res?.result || res || [];
      const sorted = [...masterList].sort((a: any, b: any) => (a.sort_order || 0) - (b.sort_order || 0));
      const ud = getUserDetail();
      const reviewingAuthorityName = ud?.name || '';
      const personalAttributes = sorted.map((m: any) => ({
        attributeMasterId: m.id,
        name: m.attribute_name,
        sortOrder: m.sort_order,
        repGrade: '',
        revGrade: '',
        initials: reviewingAuthorityName,
      }));

      this.setState({ personalAttributes }, () => {
        if (kpiReportId) {
          this.loadReportingGrades(kpiReportId);
        } else {
          this.setState({ showLoader: false });
        }
      });
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  }

  loadReportingGrades = (kpiReportId: any) => {
    getPersonalAttributeGrade({ kpiReportId, gradedByRole: "reporting" }).then((res: any) => {
      const data = res?.result || res;
      const grades = data?.grades || (Array.isArray(data) ? data : []);

      if (grades.length > 0) {
        const gradeMap: any = {};
        grades.forEach((g: any) => {
          gradeMap[g.attribute_master_id] = g;
        });

        const personalAttributes = this.state.personalAttributes.map((attr: any) => {
          const existing = gradeMap[attr.attributeMasterId];
          if (existing) {
            return { ...attr, repGrade: String(existing.grade || '') };
          }
          return attr;
        });

        this.setState({ personalAttributes }, () => {
          this.loadReviewingGrades(kpiReportId);
        });
      } else {
        this.loadReviewingGrades(kpiReportId);
      }
    }).catch(() => {
      this.loadReviewingGrades(kpiReportId);
    });
  };

  loadReviewingGrades = (kpiReportId: any) => {
    getPersonalAttributeGrade({ kpiReportId, gradedByRole: "reviewing" }).then((res: any) => {
      const data = res?.result || res;
      const grades = data?.grades || (Array.isArray(data) ? data : []);

      if (grades.length > 0) {
        const gradeMap: any = {};
        grades.forEach((g: any) => {
          gradeMap[g.attribute_master_id] = g;
        });

        const personalAttributes = this.state.personalAttributes.map((attr: any) => {
          const existing = gradeMap[attr.attributeMasterId];
          if (existing) {
            return { ...attr, revGrade: String(existing.grade || '') };
          }
          return attr;
        });

        this.setState({ personalAttributes, hasExistingGrades: true, isSubmitted: !!data?.is_submitted, showLoader: false });
      } else {
        this.setState({ showLoader: false });
      }
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  handleRevGradeChange = (index: number, value: string) => {
    let grade = parseFloat(value) || 0;
    if (grade > 10) grade = 10;
    if (grade < 0) grade = 0;
    const clampedValue = grade > 0 ? String(grade) : value;
    const personalAttributes = [...this.state.personalAttributes];
    personalAttributes[index] = { ...personalAttributes[index], revGrade: clampedValue };
    this.setState({ personalAttributes });
  };

  handleInitialsChange = (index: number, value: string) => {
    const personalAttributes = [...this.state.personalAttributes];
    personalAttributes[index] = { ...personalAttributes[index], initials: value };
    this.setState({ personalAttributes });
  };

  calculateTotalRepAttributes = () => {
    return this.state.personalAttributes.reduce((sum: number, a: any) => sum + (parseFloat(a.repGrade) || 0), 0);
  };

  calculateTotalRevAttributes = () => {
    return this.state.personalAttributes.reduce((sum: number, a: any) => sum + (parseFloat(a.revGrade) || 0), 0);
  };

  calculateOverallRepGrading = () => {
    return (this.calculateTotalRepAttributes() / 4).toFixed(2);
  };

  calculateOverallRevGrading = () => {
    return (this.calculateTotalRevAttributes() / 4).toFixed(2);
  };

  validateForm = () => {
    const { personalAttributes } = this.state;
    for (let i = 0; i < personalAttributes.length; i++) {
      if (!personalAttributes[i].revGrade || parseFloat(personalAttributes[i].revGrade) <= 0) {
        alert(`Please enter a grade for "${personalAttributes[i].name}".`);
        return false;
      }
    }
    return true;
  };

  buildAttrPayload = () => {
    const { kpiReportId, personalAttributes } = this.state;
    return {
      kpiReportId,
      gradedByRole: "reviewing",
      grades: personalAttributes.map((a: any) => ({
        attributeMasterId: a.attributeMasterId,
        grade: parseFloat(a.revGrade) || 0,
      })),
    };
  };

  callAttrApi = (callback: () => void) => {
    const { kpiReportId, hasExistingGrades } = this.state;
    if (!kpiReportId) {
      alert("KPI Report ID not found. Please go back and try again.");
      return;
    }
    this.setState({ showLoader: true });
    const payload = this.buildAttrPayload();
    const apiCall = hasExistingGrades ? updatePersonalAttributeGrade(payload) : savePersonalAttributeGrade(payload);
    apiCall.then(() => {
      this.setState({ showLoader: false, hasExistingGrades: true });
      callback();
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  handleSaveDraft = () => {
    this.callAttrApi(() => {
      alert('Saved as draft.');
    });
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    if (!this.validateForm()) return;

    const { employeeData, kpiReportId } = this.state;
    this.callAttrApi(() => {
      this.props.history.push({
        pathname: CONSTANT.component.aparReviewingManagerForm3.url,
        state: { ...employeeData, kpiReportId },
      });
    });
  };

  render() {
    const { showLoader, employeeData, personalAttributes, isSubmitted } = this.state;

    const ROMAN = ['i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x'];

    return (
      <div className="container mx-auto px-4 py-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">

                <div className="row mb-3">
                  <div className="col-md-8">
                    <h1 className="page-title">Reviewing Authority - Personal Attributes Assessment</h1>
                  </div>
                  <div className="col-md-4 text-right">
                    <button type="button" className="btn btn-sm cancel-button" onClick={() => this.props.history.goBack()}>
                      <i className="fa fa-arrow-left mr-2" />Back
                    </button>
                  </div>
                </div>
                <AparEmployeeHeader {...employeeData} detailViewerRole="reviewing" kpiReportId={this.state.kpiReportId} />

                {showLoader && <Loader />}

                {isSubmitted && (
                  <div className="alert alert-success mt-2">
                    <i className="fa fa-check-circle mr-1" /> This assessment has been submitted and is now view-only.
                  </div>
                )}

                {!showLoader && (
                  <div>
                    <h2 className="fs-5 fw-bold border-bottom pb-2 mb-4">
                      Assessment of Personal Attributes and Functional Competencies
                      <small className="text-muted fw-normal ms-2">(Weightage: 25%)</small>
                    </h2>

                    <p className="text-muted mb-3">
                      Grades should be assigned on a scale of <strong>1-10</strong>, in maximum of <strong>2 decimal numbers</strong>, with <strong>10</strong> referring to the best grade and <strong>1</strong> to the lowest grade. Weightage to this Section will be <strong>25%</strong>.
                    </p>

                    <div className="table-responsive mb-2">
                      <table className="table table-bordered table-sm align-middle">
                        <thead className="table-light">
                          <tr>
                            <th style={{ width: '8%' }}>S. No.</th>
                            <th style={{ width: '32%' }}>Personal Attributes and Functional Competencies</th>
                            <th style={{ width: '18%' }}>Grade by Reporting Authority</th>
                            <th style={{ width: '18%' }}>Grade by Reviewing Authority</th>
                            <th style={{ width: '18%' }}>Initials of Reviewing Authority</th>
                          </tr>
                        </thead>
                        <tbody>
                          {personalAttributes.map((attr: any, index: number) => (
                            <tr key={attr.attributeMasterId}>
                              <td>{ROMAN[index] || index + 1}</td>
                              <td>{attr.name}</td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control form-control-sm text-center bg-light"
                                  value={attr.repGrade || '—'}
                                  readOnly
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  step="0.01"
                                  min="1"
                                  max="10"
                                  value={attr.revGrade}
                                  onChange={(e) => this.handleRevGradeChange(index, e.target.value)}
                                  className="form-control form-control-sm text-center"
                                  placeholder="0.00"
                                  disabled={isSubmitted}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  value={attr.initials}
                                  className="form-control form-control-sm text-center"
                                  style={{ backgroundColor: '#e9ecef', color: '#212529', cursor: 'default' }}
                                  readOnly
                                />
                              </td>
                            </tr>
                          ))}
                          <tr className="table-light fw-semibold">
                            <td colSpan={2} className="text-end pe-3">Total (i to x)</td>
                            <td className="text-center">{this.calculateTotalRepAttributes().toFixed(2)}</td>
                            <td className="text-center">{this.calculateTotalRevAttributes().toFixed(2)}</td>
                            <td></td>
                          </tr>
                          <tr className="table-secondary fw-bold">
                            <td colSpan={2} className="text-end pe-3">Overall Grading (Total / 4)</td>
                            <td className="text-center">{this.calculateOverallRepGrading()}</td>
                            <td className="text-center">{this.calculateOverallRevGrading()}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="border p-2 mt-2 mb-3 fst-italic text-danger">
                      <p className="mb-0">All the personal attributes and functional competencies (S. No. i to x) carry equal weights. Overall grading is to be computed by dividing the total grade by 4 and rounding off to 2 decimals.</p>
                    </div>

                    <div className="text-muted mb-4">
                      <strong>Note a:</strong> Personal Attributes and Functional Competencies should be judged in the backdrop of Leadership ability to lead by example, particularly in challenging circumstances.<br />
                      <strong>Note b:</strong> Item nos. (iv) and (v) on the team work should be evaluated based on the ability of the incumbent to perform as a member of a team and enhance team performance.
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-3">
                      <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.history.goBack()}>
                        Back
                      </button>
                      {!isSubmitted && (
                        <button type="button" className="btn btn-secondary" onClick={this.handleSaveDraft} disabled={showLoader}>
                          {showLoader ? "Saving..." : "Save Draft"}
                        </button>
                      )}
                      {!isSubmitted && (
                        <button type="button" className="btn btn-primary" onClick={this.onSubmit} disabled={showLoader}>
                          {showLoader ? "Saving..." : "Save & Next"} <i className="fa fa-arrow-right ml-1" />
                        </button>
                      )}
                      {isSubmitted && (
                        <button type="button" className="btn btn-primary" onClick={() => {
                          const { employeeData, kpiReportId } = this.state;
                          this.props.history.push({
                            pathname: CONSTANT.component.aparReviewingManagerForm3.url,
                            state: { ...employeeData, kpiReportId },
                          });
                        }}>
                          Next <i className="fa fa-arrow-right ml-1" />
                        </button>
                      )}
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(aparReviewingManagerForm2);
